<template>
  <div id="deferredPayment">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'deferredPayment'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/financial/deferredPayment/DeferredPayment.vue